import React, {Component} from 'react';
import './RmRadioField.css';
import PropTypes from 'prop-types';
import RmField from "./RmField";

export default class RmRadioField extends Component {
    handleChange(e) {
        if (this.props.onChange) {
            this.props.onChange(e.target.value);
        }
    }

    handleRadioCheck(value, e) {
        if (e.target.checked) {
            this.props.onChange(value);
        }
    }

    render() {
        let {className, ...props} = this.props;

        if (className) {
            className += ' ';
        } else {
            className = '';
        }

        className += 'RmRadioField';

        let radios = [];

        for (let iValue in this.props.options) {
            if (this.props.options.hasOwnProperty(iValue)) {
                let iLabel = this.props.options[iValue];
                let iKey = `${this.props.id}_${iLabel}`;

                radios.push(
                    <div className={"RmRadioField__subopt"} key={iKey}>
                        <input className="RmRadioField__radio" type="radio"
                               name={this.props.id} id={iKey} value={iLabel}
                               onChange={this.handleRadioCheck.bind(this, iValue)}
                               checked={this.props.value === iValue}
                        />
                        <label className="RmRadioField__label" htmlFor={iKey}>{iLabel}</label>
                    </div>
                );
            }
        }

        let io = <div className={"RmRadioField__inner"}>{radios}</div>;

        return (
            <RmField {...props} disableClear={true} className={className}
                     inputType={"radio"} nonUnique={false} inputOverride={io}/>
        );
    }
}

RmRadioField.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    iconName: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    marginOff: PropTypes.bool,
    className: PropTypes.string,
    options: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/Forms/RmRadioField.js